import React, { ComponentPropsWithoutRef, ElementType } from 'react';
import classnames from 'classnames';
import ReactDatePicker from 'react-datepicker';

import { useMobile } from '../../responsive/Responsive';
import Input from '../input/Input';

import 'react-datepicker/dist/react-datepicker.css';
import './DatePicker.scss';

export interface DatepickerProps extends ComponentPropsWithoutRef<ElementType> {
  className?: string;
  value?;
  placeholder?: string;
}

const Datepicker = ({
  className,
  value,
  placeholder,
  ...props
}: DatepickerProps) => {
  const isMobile = useMobile();

  return (
    <div className={classnames('date-picker', className)}>
      <ReactDatePicker
        className="date-picker__input"
        calendarClassName="date-picker__calendar"
        clearButtonClassName="date-picker__clear-button"
        popperClassName="date-picker__popper"
        customInput={<Input />}
        isClearable={true}
        placeholderText={placeholder}
        scrollableYearDropdown={true}
        showMonthDropdown={true}
        showYearDropdown={true}
        dropdownMode="select"
        showPopperArrow={false}
        selected={value}
        showTimeInput={true}
        fixedHeight={true}
        withPortal={isMobile}
        dateFormat="Pp"
        timeInputLabel="Time:"
        {...props}
      />
    </div>
  );
};

export default Datepicker;
